import { FormControl, FormLabel, Input, Select, Button, Box, Center, VStack, Heading, Image } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { IAceleraMagentaStore } from '../../../interfaces/IAceleraMagentaStore'
import AceleraMagentaService from '../../../services/AceleraMagenta/AceleraMagentaService'
import EmployeeService from '../../../services/Employee/EmployeeService'

interface IEmployee {
  id: number
  name: string
}

interface IForm {
  selectedEmployee: string
  employee: {
    name: string
    email: string
    birthdate: string
    nickname: string
    position: string
    organizationalLevel: string
  }
  supervisor: string
  emailSupervisor: string
}

export default function AceleraMagentaNewPage() {
  const employeeService = new EmployeeService()
  const aceleraMagentaService = new AceleraMagentaService()

  const navigate = useNavigate()

  const [form, setForm] = useState<IForm>({
    selectedEmployee: '0',
    employee: {
      name: '',
      email: '',
      birthdate: '',
      nickname: '',
      position: '',
      organizationalLevel: ''
    },
    supervisor: '',
    emailSupervisor: ''
  })
  const [employees, setEmployees] = useState<IEmployee[]>([{ id: 0, name: 'Novo Funcionário' }])

  useEffect(() => {
    employeeService.list().then((response) => {
      setEmployees([
        { id: 0, name: 'Novo Funcionário' },
        ...response.data.map((employee: { id: number; name: string }) => ({ id: employee.id, name: employee.name }))
      ])
    })
  }, [])

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const aceleraMagentaData: IAceleraMagentaStore = {
      employee_id: Number(form.selectedEmployee),
      supervisor: form.supervisor,
      email_supervisor: form.emailSupervisor
    }

    if (aceleraMagentaData.employee_id === 0) {
      aceleraMagentaData.employee = {
        name: form.employee.name,
        email: form.employee.email,
        birthdate: form.employee.birthdate,
        nickname: form.employee.nickname,
        position: form.employee.position,
        organizational_level: form.employee.organizationalLevel
      }
    }

    const aceleraMagenta = await aceleraMagentaService.store(aceleraMagentaData)

    navigate(`/acelera-magenta/${aceleraMagenta.data.id}`)
  }

  return (
    <Center marginTop={5}>
      <Box borderWidth="1px" p="5" borderRadius="lg" w="50%">
        <Center>
          <Image src="/img/acelera-magenta.png" alt="Acelera Magenta" w="65%" marginBottom="10" />
        </Center>
        <Heading as="h1" size="lg" marginBottom="5" textTransform="uppercase">
          Novo Acelera Magenta
        </Heading>
        <form onSubmit={handleSubmit}>
          <VStack spacing="4">
            {form.selectedEmployee === '0' && (
              <>
                <FormControl isRequired>
                  <FormLabel>Nome completo</FormLabel>
                  <Input
                    type="text"
                    value={form.employee.name}
                    onChange={(event) => setForm({ ...form, employee: { ...form.employee, name: event.target.value } })}
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>E-mail</FormLabel>
                  <Input
                    type="email"
                    value={form.employee.email}
                    onChange={(event) =>
                      setForm({ ...form, employee: { ...form.employee, email: event.target.value } })
                    }
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Data de nascimento</FormLabel>
                  <Input
                    type="date"
                    value={form.employee.birthdate}
                    onChange={(event) =>
                      setForm({ ...form, employee: { ...form.employee, birthdate: event.target.value } })
                    }
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Como gosta de ser chamado(a)?</FormLabel>
                  <Input
                    type="text"
                    value={form.employee.nickname}
                    onChange={(event) =>
                      setForm({ ...form, employee: { ...form.employee, nickname: event.target.value } })
                    }
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Cargo</FormLabel>
                  <Input
                    type="text"
                    value={form.employee.position}
                    onChange={(event) =>
                      setForm({ ...form, employee: { ...form.employee, position: event.target.value } })
                    }
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Nível organizacional do cargo</FormLabel>
                  <Select
                    placeholder="Selecione um nível organizacional"
                    value={form.employee.organizationalLevel}
                    onChange={(event) =>
                      setForm({ ...form, employee: { ...form.employee, organizationalLevel: event.target.value } })
                    }
                  >
                    <option value="operacional">Operacional</option>
                    <option value="tatico">Tático</option>
                    <option value="estrategico">Estratégico</option>
                  </Select>
                </FormControl>
              </>
            )}
            <FormControl isRequired>
              <FormLabel>Gestor(a) imediato(a)</FormLabel>
              <Input
                type="text"
                value={form.supervisor}
                onChange={(event) => setForm({ ...form, supervisor: event.target.value })}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>E-mail do(a) gestor(a) imediato(a)</FormLabel>
              <Input
                type="email"
                value={form.emailSupervisor}
                onChange={(event) => setForm({ ...form, emailSupervisor: event.target.value })}
              />
            </FormControl>
            <Button colorScheme="magenta" type="submit">
              Iniciar Acelera Magenta
            </Button>
          </VStack>
        </form>
      </Box>
    </Center>
  )
}
